/**
 * Presentation rules shared by ConversionDialogShell (copy + download).
 */

export function shouldShowUnsupportedFormatsWarning({
  unsupportedFormatsCount,
  isOriginalPreset,
  shouldFormatBeDisabled,
}) {
  return unsupportedFormatsCount > 0
    && !isOriginalPreset
    && !shouldFormatBeDisabled;
}

/**
 * Bulk download button count. On a converting preset, non-convertible assets are
 * skipped by the pipeline, so the label reflects only assets that will be processed.
 * On Original every selected asset is included.
 */
export function getEffectiveBulkActionCount({
  selectionCount,
  unsupportedFormatsCount,
  isOriginalPreset,
}) {
  if (isOriginalPreset || unsupportedFormatsCount <= 0) {
    return selectionCount;
  }
  return selectionCount - unsupportedFormatsCount;
}
